module.exports = __webpack_public_path__ + "static/media/m_hairstyle_pompadour_front.416834ba.png";